var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.map)?_c('div',{staticClass:"neko-map-tab"},[_c('map-container',{attrs:{"map":_vm.map}}),_c('map-control',{attrs:{"map":_vm.map}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }